import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import {
  Select,
  Button,
  DatePicker,
  // $FlowFixMe
} from '@bijie/react-bnb';
import { getLabel } from '../../utils/i18n';

const { RangePicker } = DatePicker;

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  .bnc-select-sm {
    padding-top: 18px;
  }
  .bnc-select-selection__placeholder {
    color: #848E9C;
    opacity: .5;
  }
`;

const OptionItem = styled.span`
  padding-right: 35px;
  > .bnc-btn {
    margin-right: 10px;
    min-width: 90px;
  }
  .coin-select {
    width: 100px;
  }
  .type-select {
    width: 130px;
  }
`;
const Label = styled.label`
  position: absolute;
  font-size: 12px;
  color: #848e9c;
`;

type Props = {
  i18n: Object,
  locale: string,
  coinList: Array<Object>,
  fetchData: Function,
  queryRef: Object,
};

const defaultDate = [
  moment().subtract(7, 'days'),
  moment(),
];

const Conditions = ({
  i18n, locale, coinList, fetchData, queryRef,
}: Props) => {
  const [asset, setAsset] = useState('');
  const [dateValue, setDateValue] = useState(defaultDate);
  const rest = () => {
    setAsset(undefined);
    setDateValue(defaultDate);
  };
  queryRef.current = {
    asset,
    createTimestampStart: dateValue[0].valueOf(),
    createTimestampEnd: dateValue[1].valueOf(),
  };

  return (
    <Container>
      <OptionItem>
        <Label>{getLabel('exchange-common-coin', i18n)}</Label>
        <Select
          size="sm"
          value={asset}
          className="coin-select"
          showSearch={true}
          placeholder={getLabel('exchange-common-searchcoin', i18n)}
          defaultActiveFirstOption={false}
          onChange={v => setAsset(v)}
        >
          {
            coinList.map((coin, idx) => (
              <Select.Option key={idx} value={coin.key}>{coin.label}</Select.Option>
            ))
          }
        </Select>
      </OptionItem>
      <OptionItem>
        <RangePicker
          size="sm"
          value={dateValue}
          formatter="YYYY-MM-DD"
          placeholder={getLabel('exchange-common-date', i18n)}
          disabledDate={current => !moment().isAfter(current)}
          onChange={setDateValue}
          maxRange={[0, 3, 0]}
          locale={locale}
          width="210px"
          inputShrink={true}
          dateInputPlaceholder={['start', 'end']}
        />
      </OptionItem>
      <OptionItem>
        <Button type="default" onClick={rest}>{getLabel('exchange-common-reset', i18n)}</Button>
        <Button type="primary" onClick={() => fetchData()} outline={true}>{getLabel('exchange-common-search', i18n)}</Button>
      </OptionItem>
    </Container>
  );
};
Conditions.defaultProps = {
  coinList: [],
};

export default React.memo(Conditions);
